import { SupabaseService } from "../../services/supabase.service";
import { of } from "rxjs";
import { map, tap } from "rxjs/operators";

export const creditCardTables = [
  'settled',
  'workflow',
  'workflow_user',
  'payment',
  'invoice',
  'invoice_version',
  'invoice_version_client',
  'estimate',
  'estimate_version',
  'estimate_version_client',
  'paid',
  'refunded',
  'chargeback'
];

export function initCreditCardSettled(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'settled_total',
      schema: businessId,
      fn: 'settled_total',
      tables: creditCardTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(r => r[0])
  );
}

export function initCreditCardPending(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'pending_total',
      schema: businessId,
      fn: 'pending_total',
      tables: creditCardTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(r => r[0])
  );
}

export function initCreditPreChargebacks(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return of({
    preChargebacks: 0,
    arbitration: 0,
    count: 2,
  });
}

export function initCreditCardChargebacks(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return of({
    chargebacks: 0,
    resolved: 0,
    count: 2
  });
}

export function initCreditCardRefunds(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'refunds_total',
      schema: businessId,
      fn: 'refunds_total',
      tables: creditCardTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(r => r[0])
  );
}

export function initCreditCardSurcharge(
  supabaseService: SupabaseService,
  businessId: string,
  selectedUsers: number[] | null,
  startTime: Date,
  endTime: Date
) {
  return supabaseService.rpc({
      cName: 'surcharge_total',
      schema: businessId,
      fn: 'surcharge_total',
      tables: creditCardTables,
      options: {
        start_time: startTime,
        end_time: endTime,
        ...(selectedUsers && { selected_users: selectedUsers })
      }
    },
    _ => null,
    'report'
  ).pipe(
    map(r => r[0])
  );
}
